import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { wineNaming } from "@/js/wine/wine.js";
import ClassificationPopin from "./ClassificationPopin.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "Appellation",
  components: {
    ClassificationPopin: ClassificationPopin,
    confirm: confirmationComponent,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    baseModel: Object,
    mode: String,
    isEdit: Boolean
  },
  data: function data() {
    return {
      isLoadingRegions: true,
      regions: [],
      isLoadingClassifications: true,
      classifications: [],
      isLoadingAppellations: true,
      existingRegionAppellations: [],
      isShowExisitingRegionAppellations: false,
      classificationPopinShown: false,
      manageExistingAppellation: {
        form: {
          valid: false
        },
        model: {
          id_appellation: null,
          isWine: false,
          isSpirit: false,
          appellation: "",
          id_classification: null
        },
        products: [],
        error: {
          delete: null
        }
      },
      saveAppellationCancellationToken: null,
      saveExistingAppellationCancellationToken: null,
      deleteExistingAppellationCancellationToken: null,
      managedExceptions: {
        error: {
          wine_attached: "At least one wine is attached this classification. It can't be deleted."
        },
        warning: {
          appellation_exists: "An appellation with same configuration already exists."
        },
        info: {}
      },
      form: {
        valid: false
      },
      productType: null,
      formRules: formRules,
      filterVAutocomplete: filterVAutocomplete,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    canManageAppellations: function canManageAppellations() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_APPELLATION);
    },
    isAuthorized: function isAuthorized() {
      return isAdminNotConsultant(this.loggedUserData) && this.canManageAppellations;
    },
    getProductTypes: function getProductTypes() {
      return [{
        id: "wine",
        name: "Wine"
      }, {
        id: "spirit",
        name: "Spirit"
      }];
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.isAuthorized) {
              _context.next = 3;
              break;
            }
            _this2.cancel();
            return _context.abrupt("return");
          case 3:
            // if (this.baseModel.isWine) this.productType = "wine"
            // if (this.baseModel.isSpirit) this.productType = "spirit"

            _this2.getRegions();
            _this2.getClassifications();
            _this2.getRegionAppellations();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getRegions: function getRegions() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoadingRegions = true;
              _this = _this3;
              _context2.next = 4;
              return request("/v1/regions", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, {}, "Unable to load regions list");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 4:
              response = _context2.sent;
              _this3.isLoadingRegions = false;
              if (response.data !== null) {
                _this3.regions = _toConsumableArray(response.data);
                _this3.updateProductType();
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getClassifications: function getClassifications() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isLoadingClassifications = true;
              _this = _this4;
              _context3.next = 4;
              return request("/v1/appellations/classifications", "get", null, true, "api").catch(function (e) {
                _this.isLoadingClassifications = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load classifications list");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context3.sent;
              _this4.isLoadingClassifications = false;
              if (response.data !== null) _this4.classifications = _toConsumableArray(response.data);
              if (_this4.baseModel.id_classification) {
                if (!_this4.classifications.some(function (x) {
                  return x.id_classification === _this4.baseModel.id_classification;
                })) _this4.baseModel.id_classification = null;
              }
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    changeRegion: function changeRegion() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.updateProductType();
              _context4.next = 3;
              return _this5.getRegionAppellations();
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getRegionAppellations: function getRegionAppellations() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.isShowExisitingRegionAppellations = false;
              if (!_this6.baseModel.region.id) {
                _context5.next = 11;
                break;
              }
              _this6.isLoadingAppellations = true;
              _this = _this6;
              _context5.next = 6;
              return request("/v1/regions/".concat(_this6.baseModel.region.id, "/appellations"), "get", null, true, "api").catch(function (e) {
                _this.isLoadingAppellations = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load existing appellations");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 6:
              response = _context5.sent;
              _this6.isLoadingAppellations = false;
              if (response.data != null) _this6.existingRegionAppellations = _toConsumableArray(response.data);
              _context5.next = 12;
              break;
            case 11:
              _this6.existingRegionAppellations = [];
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    toggleShowAppellations: function toggleShowAppellations() {
      this.isShowExisitingRegionAppellations = !this.isShowExisitingRegionAppellations;
    },
    save: function save() {
      if (!this.isEdit) {
        this.saveAppellation("post");
      } else {
        this.saveAppellation("put");
      }
    },
    saveAppellation: function saveAppellation(verb) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.$EventBus.$emit("loading", true);
              _this = _this7;
              data = {
                id: _this.baseModel.id_appellation,
                name: _this.baseModel.appellation,
                isWine: _this.baseModel.isWine,
                isSpirit: _this.baseModel.isSpirit,
                regionId: _this.baseModel.region.id,
                classificationId: _this.baseModel.id_classification
              };
              _context6.prev = 3;
              _context6.next = 6;
              return request("/v1/appellations", verb, data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save appellation");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 6:
              response = _context6.sent;
              if (response.status == 201 || response.status == 200) {
                _this7.$toasted.show("Appellation saved.", {
                  type: "success"
                });
                _this7.$EventBus.$emit("loading", false);
                _this7.$emit("saved", response.data ? response.data : _this.baseModel.id_appellation);
              }
              _context6.next = 12;
              break;
            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](3);
            case 12:
              _this7.$EventBus.$emit("loading", false);
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[3, 10]]);
      }))();
    },
    updateProductType: function updateProductType() {
      var _this8 = this;
      this.baseModel.isWine = false;
      this.baseModel.isSpirit = false;
      if (this.baseModel.region.id) {
        var region = this.regions.find(function (x) {
          return x.id == _this8.baseModel.region.id;
        });
        if (region) {
          if (region.isSpiritRegion) {
            this.baseModel.isSpirit = true;
          } else if (region.isWineRegion) {
            this.baseModel.isWine = true;
          }
        }
      }
      if (this.baseModel.isWine) this.productType = "wine";
      if (this.baseModel.isSpirit) this.productType = "spirit";
    },
    saveEditExistingAppellation: function saveEditExistingAppellation() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this9$saveExistingAp;
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this9.$EventBus.$emit("loading", true);
              (_this9$saveExistingAp = _this9.saveExistingAppellationCancellationToken) === null || _this9$saveExistingAp === void 0 || _this9$saveExistingAp.cancel();
              _this9.saveExistingAppellationCancellationToken = axios.CancelToken.source();
              _this = _this9;
              data = {
                regionId: _this.baseModel.region.id,
                id: _this.manageExistingAppellation.model.id_appellation,
                name: _this.manageExistingAppellation.model.appellation,
                isWine: _this.manageExistingAppellation.model.isWine,
                isSpirit: _this.manageExistingAppellation.model.isSpirit,
                classificationId: _this.manageExistingAppellation.model.id_classification
              };
              _context7.prev = 5;
              _context7.next = 8;
              return request("/v1/appellations", "put", data, true, "api", null, _this.saveExistingAppellationCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to save appellation");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 8:
              response = _context7.sent;
              if (!(response.status == 201 || response.status == 200)) {
                _context7.next = 14;
                break;
              }
              _this.$toasted.show("Appellation saved.", {
                type: "success"
              });
              _context7.next = 13;
              return _this.getRegionAppellations();
            case 13:
              _this9.closeEditExistingAppellation();
            case 14:
              _context7.next = 18;
              break;
            case 16:
              _context7.prev = 16;
              _context7.t0 = _context7["catch"](5);
            case 18:
              _this9.$EventBus.$emit("loading", false);
            case 19:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[5, 16]]);
      }))();
    },
    cancel: function cancel() {
      this.$emit("cancel");
    },
    openClassificationPopin: function openClassificationPopin() {
      var _this10 = this;
      this.classificationPopinShown = true;
      this.$nextTick(function () {
        _this10.$refs.classificationPopin.open();
      });
    },
    closeClassificationPopin: function closeClassificationPopin(response) {
      if (response.confirmed) {
        this.baseModel.id_classification = +response.data.value;
      }
      this.getClassifications();
      this.classificationPopinShown = false;
    },
    deleteAppellation: function deleteAppellation(id_appellation) {
      var _this11 = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to delete this appellation ?", {
        color: "red"
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(confirm) {
          var _this11$deleteExistin, _this;
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                if (!confirm) {
                  _context9.next = 17;
                  break;
                }
                _this11.closeEditExistingAppellation();
                _context9.prev = 2;
                _this11.$EventBus.$emit("loading", true);
                (_this11$deleteExistin = _this11.deleteExistingAppellationCancellationToken) === null || _this11$deleteExistin === void 0 || _this11$deleteExistin.cancel();
                _this11.deleteExistingAppellationCancellationToken = axios.CancelToken.source();
                _this = _this11;
                _context9.next = 9;
                return request("/v1/appellations/".concat(id_appellation), "delete", null, true, "api", null, _this11.deleteExistingAppellationCancellationToken).catch(/*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(e) {
                    var errorData;
                    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                      while (1) switch (_context8.prev = _context8.next) {
                        case 0:
                          errorData = getErrorData(e, _this.managedExceptions, "Unable to delete appellation");
                          handleErrorData(_this, errorData);
                          if ((errorData === null || errorData === void 0 ? void 0 : errorData.code) === "wine_attached") {
                            _this.getErrorWinesAttached(id_appellation);
                          }
                          throw e;
                        case 4:
                        case "end":
                          return _context8.stop();
                      }
                    }, _callee8);
                  }));
                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              case 9:
                _this11.getRegionAppellations();
                _this11.closeEditExistingAppellation();
                _this11.$toasted.show("Appellation deleted", {
                  type: "success"
                });
                _context9.next = 16;
                break;
              case 14:
                _context9.prev = 14;
                _context9.t0 = _context9["catch"](2);
              case 16:
                _this11.$EventBus.$emit("loading", false);
              case 17:
              case "end":
                return _context9.stop();
            }
          }, _callee9, null, [[2, 14]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getErrorWinesAttached: function getErrorWinesAttached(id_appellation) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return request("/v1/appellations/".concat(id_appellation, "/wines"), "get", null, true, "api");
            case 2:
              response = _context10.sent;
              if (response.data) {
                _this12.manageExistingAppellation.error.delete = {
                  id_appellation: id_appellation,
                  code: "wine_attached",
                  data: _toConsumableArray(response.data),
                  isDetailsShown: false
                };
              }
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    toggleShowErrorDeleteWinesAttached: function toggleShowErrorDeleteWinesAttached() {
      this.manageExistingAppellation.error.delete.isDetailsShown = !this.manageExistingAppellation.error.delete.isDetailsShown;
    },
    startEditAppellation: function startEditAppellation(id_appellation) {
      this.manageExistingAppellation.model = _objectSpread({}, this.existingRegionAppellations.find(function (x) {
        return x.id_appellation === id_appellation;
      }));
      this.resetErrorsManagingExisting();
    },
    closeEditExistingAppellation: function closeEditExistingAppellation() {
      this.manageExistingAppellation.model = {
        id_appellation: null,
        appellation: "",
        id_classification: null
      };
      this.resetErrorsManagingExisting();
    },
    resetErrorsManagingExisting: function resetErrorsManagingExisting() {
      this.manageExistingAppellation.error = {
        delete: null
      };
    },
    formatWineNaming: function formatWineNaming(wineNamingData) {
      return wineNaming(this.$whitelabel, wineNamingData, true, true, false);
    }
  }
};